<product-range-banner class="block"
                      [variant]="product?.rangeContentVariant"
                      [product]="product"></product-range-banner>